import { Switch } from "react-router-dom";
import AuthRoute from "components/AuthRoute";
import OrcamentosListaPage from "./Listagem/index";
import OrcamentoDetalhesPage from "./Detalhes/index";
import { PermissaoEnum } from "core/resources/enums/permissao";

function OrcamentosPages() {
  return (
    <Switch>
      <AuthRoute
        exact
        path="/administracao/orcamento"
        component={OrcamentosListaPage}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Orcamento.Visualizar,
        ]}
      />
      <AuthRoute
        exact
        path="/administracao/orcamento/novo"
        component={OrcamentoDetalhesPage}
        permissions={[PermissaoEnum.Backoffice.Administrativo.Orcamento.Criar]}
      />
      <AuthRoute
        path="/administracao/orcamento/:id"
        component={OrcamentoDetalhesPage}
        permissions={[PermissaoEnum.Backoffice.Administrativo.Orcamento.Editar]}
      />
    </Switch>
  );
}

export default OrcamentosPages;
